// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  ImportActionResult,
  ImportActionResultFromJSON,
  ImportActionResultToJSON,
  ImportPayload,
  ImportPayloadFromJSON,
  ImportPayloadToJSON,
  ImportSummary,
  ImportSummaryFromJSON,
  ImportSummaryToJSON,
  QueueStatus,
  QueueStatusFromJSON,
  QueueStatusToJSON,
} from "../models";

export interface GetImportQueueStatusRequest {
  importTaskID: string;
}

export interface GetImportSummaryRequest {
  importTaskID: string;
}

export interface QueueImportRequest {
  importPayload?: ImportPayload;
}

/**
 * no description
 */
export class TestCaseImportApi extends runtime.BaseAPI {
  /**
   * Returns status of the import queue
   */
  async getImportQueueStatusRaw(
    requestParameters: GetImportQueueStatusRequest
  ): Promise<runtime.ApiResponse<QueueStatus>> {
    if (
      requestParameters.importTaskID === null ||
      requestParameters.importTaskID === undefined
    ) {
      throw new runtime.RequiredError(
        "importTaskID",
        "Required parameter requestParameters.importTaskID was null or undefined when calling getImportQueueStatus."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/test_cases/importQueueStatus/{importTaskID}`.replace(
        `{${"importTaskID"}}`,
        encodeURIComponent(String(requestParameters.importTaskID))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      QueueStatusFromJSON(jsonValue)
    );
  }

  /**
   * Returns status of the import queue
   */
  async getImportQueueStatus(
    requestParameters: GetImportQueueStatusRequest
  ): Promise<QueueStatus> {
    const response = await this.getImportQueueStatusRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns summary of the import task
   */
  async getImportSummaryRaw(
    requestParameters: GetImportSummaryRequest
  ): Promise<runtime.ApiResponse<ImportSummary>> {
    if (
      requestParameters.importTaskID === null ||
      requestParameters.importTaskID === undefined
    ) {
      throw new runtime.RequiredError(
        "importTaskID",
        "Required parameter requestParameters.importTaskID was null or undefined when calling getImportSummary."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/test_cases/importSummary/{importTaskID}`.replace(
        `{${"importTaskID"}}`,
        encodeURIComponent(String(requestParameters.importTaskID))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ImportSummaryFromJSON(jsonValue)
    );
  }

  /**
   * Returns summary of the import task
   */
  async getImportSummary(
    requestParameters: GetImportSummaryRequest
  ): Promise<ImportSummary> {
    const response = await this.getImportSummaryRaw(requestParameters);
    return await response.value();
  }

  /**
   * Adds an import queue
   * Adds an import queue
   */
  async queueImportRaw(
    requestParameters: QueueImportRequest
  ): Promise<runtime.ApiResponse<ImportActionResult>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/testcases/queueImport`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ImportPayloadToJSON(requestParameters.importPayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ImportActionResultFromJSON(jsonValue)
    );
  }

  /**
   * Adds an import queue
   * Adds an import queue
   */
  async queueImport(
    requestParameters: QueueImportRequest
  ): Promise<ImportActionResult> {
    const response = await this.queueImportRaw(requestParameters);
    return await response.value();
  }
}
